import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useLogging } from "../../Shared/hooks/useLogging/useLogging";
import { LoginRegisterShell } from "../LoginRegisterShell";
import { LoginForm } from "./LoginForm";
export const Login = () => {
    const { logReactPixelPageView, gaPageView } = useLogging();
    useEffect(() => {
        logReactPixelPageView();
        gaPageView("Login", location.pathname);
    }, []);
    return (_jsx(LoginRegisterShell, { children: _jsx(LoginForm, {}) }));
};
